'use client';

import { PropsWithChildren } from 'react';
import { Language } from '@/shared/consts/language';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { getTranslation } from '../i18n';
import { getQueryClient } from '../utils/query/getQueryClient';
import { LanguageContext } from './language-context';
import { I18nContext } from './i18n-context';
import { CookieProvider } from '@/shared/providers/cookie';
import { CookieObject } from '@/shared/consts/cookie-key';

interface ProviderGroupProps {
  values: {
    language: Language;
    cookieObject: CookieObject;
  };
}

export function ProviderGroup(props: PropsWithChildren<ProviderGroupProps>) {
  const { values, children } = props;
  const { language, cookieObject } = values;
  const translation = getTranslation(language);
  const queryClient = getQueryClient();

  return (
    <CookieProvider value={cookieObject}>
      <LanguageContext.Provider value={language}>
        <I18nContext.Provider value={translation}>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools />
            {children}
          </QueryClientProvider>
        </I18nContext.Provider>
      </LanguageContext.Provider>
    </CookieProvider>
  );
}
